/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-14 15:37:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:09:52                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * WorkorderDashCard - Display visit
*/

/* Imports */
import { BuildingOfficeIcon, CalendarIcon, MapPinIcon, UserIcon, UserPlusIcon } from "@heroicons/react/24/solid";
import { Typography } from "@material-tailwind/react";
/***/

/* Components */
import AddressDisplay from "../address/AddressDisplay";
/***/

/* Styles */
import "./WorkorderDashCard.scss";
import { t } from "../../../i18n";
import TechnicianDisplay from "../technician/TechnicianDisplay";
import CustomerDisplay from "../customer/CustomerDisplay";
import WorkordersStatusDisplay from "../workorder-status/WorkordersStatusDisplay";
/***/

/**
* WorkorderDashCard - Display visit
* @param visit - visit data
* @param onClick - on click event, trigger on component click
*/
export default function WorkorderSearchCard({
  workorder,
  onClick
}: {
  workorder: EasyTech.Workorder,
  onClick?: () => void
}) {
  return (
  <div className="visit-card" onClick={() => onClick && onClick()}>
    <div className="flex justify-between">
        <Typography className="text-blue-600 hover:underline">
          {workorder.ref}
        </Typography>

        <WorkordersStatusDisplay status={workorder.status} />
      </div>

      <div className="icon-text-container">
        <div className="icon-text">
          <BuildingOfficeIcon className="w-5" />
          <CustomerDisplay customer={workorder.customer} />
        </div>
        <div className="icon-text">
          <MapPinIcon className="w-5" />
          <AddressDisplay address={workorder.address} zone={workorder.zone}/>
        </div>
      </div>
      <div className="icon-text-container">
        {(workorder && workorder.technician) && (
          <div className="icon-text">
            <UserIcon className="w-5" />
            <TechnicianDisplay technician={workorder.technician} />
          </div>
        )}
        {workorder && workorder.schedule ? (
          <div className="icon-text">
            <CalendarIcon className="w-5" />
            <Typography>
              {t("common:scheduledOn") + " "}
              {new Date(workorder.schedule.start).toLocaleDateString()}
            </Typography>
          </div>
        ) : workorder && workorder.time && workorder.time.start ? (
          <div className="icon-text">
            <UserPlusIcon className="w-5" />
            <Typography>
              {t("common:startedOn") + " "}
              {new Date(workorder.time.start).toLocaleDateString()}
            </Typography>
          </div>
        ) : null}
      </div>
  </div>
  );
}
/***/
